import React, { useRef, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux'
import { setEndChatConfirm, endChat } from 'store/app/app.actions';
import style from './endchatdialog.module.scss';
import useApp from 'hooks/useApp';
import ReactDOM from 'react-dom';

interface Props { 
    endChatConfirm: boolean,
}

const ANIMATION_DURATION = 500;

const EndChatDialog: React.FC<Props> = (props) => {
    const dispatch = useDispatch();
    const { language, appTextTranslations } = useApp();
    const body: HTMLBodyElement = document.getElementsByTagName('body')[0];
    const endButtonRef = useRef<HTMLButtonElement | null>(null);
    const [isVisible, setIsVisible] = useState(props.endChatConfirm);

    useEffect(() => {
        if (props.endChatConfirm) {
            setIsVisible(true)
            endButtonRef.current?.focus();
        }
    }, [props.endChatConfirm]);
    
    useEffect(() => {
        if (!isVisible) {
            const timeoutId = setTimeout(() => {
                dispatch(setEndChatConfirm(false));
            }, ANIMATION_DURATION);

            return () => {
                clearTimeout(timeoutId);
            };
        }
    }, [isVisible]);

    const endChatText =
        appTextTranslations?.endChatDialogue?.[language].endChatText ??
        'Are you sure you want to end the chat?';
    const endChatCancelMessage =
        appTextTranslations?.endChatDialogue?.[language].endChatCancel ?? 'Cancel';
    const endChatConfirmMessage =
        appTextTranslations?.endChatDialogue?.[language].endChatConfirm ?? 'End Chat';

    const onClick = (e: React.MouseEvent) => {
        if (!props.endChatConfirm) return;

        if ((e.target as HTMLElement).classList[0] === style.overlay) {
            setIsVisible(false)
        }
    }

    if (!props.endChatConfirm) return null

    return ReactDOM.createPortal(
        <div onClick={onClick} className={`${isVisible ? style.overlay : `${style.overlay} ${style.closed}`}`} role="dialog" aria-modal="true" aria-describedby='modal-description'>
            <div className={`${isVisible ? style.wrapper : `${style.wrapper} ${style.closed}`}`}>
                <div className={style.endChatOptions}>
                    <p id="modal-description" className={style.message}>{endChatText}</p>
                    <div className={style.endChatOptionsRow}>
                        <button ref={endButtonRef} className={style.cancelButton} onClick={() => setIsVisible(false)}>
                            {endChatCancelMessage}
                        </button>
                        <button className={style.okButton} onClick={() => dispatch(endChat())}>
                            {endChatConfirmMessage}
                        </button>
                    </div>
                </div>
            </div>
        </div>,
        body
    )
}

export default EndChatDialog;